import { createTRPCProxyClient, httpBatchLink } from "@trpc/client";
import type { AppRouter } from "../../v3/src/router.js";

function getApiBaseUrl(): string {
  const apiUrlBase = process.env.REACT_APP_API_URL;
  return apiUrlBase ?? "http://localhost:3000";
}

export function createAppTrpcClient(getAccessToken: () => Promise<string>) {
  return createTRPCProxyClient<AppRouter>({
    links: [
      httpBatchLink({
        url: `${getApiBaseUrl()}/trpc`,
        headers: async () => {
          const token = await getAccessToken();
          return {
            Authorization: `Bearer ${token}`,
          };
        },
      }),
    ],
  });
}
